// write by cursor
// 生成时间: 2025-07-29 19:45:14
// 集成的Token会话管理

/**
 * Token存储键名 - write by cursor
 */
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

/**
 * 获取访问令牌 - write by cursor
 */
export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
}

/**
 * 获取刷新令牌 - write by cursor
 */
export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

/**
 * 设置访问令牌 - write by cursor
 */
export function setAccessToken(token: string): void {
  try {
    if (token) {
      localStorage.setItem(ACCESS_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
  } catch (error) {
    console.error('Failed to set access token:', error);
  }
}

/**
 * 设置刷新令牌 - write by cursor
 */
export function setRefreshToken(token: string): void {
  try {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  } catch (error) {
    console.error('Failed to set refresh token:', error);
  }
}

/**
 * 清除所有Token - write by cursor
 */
export function clearTokens(): void {
  setAccessToken('');
  setRefreshToken('');
}

/**
 * 检查是否有有效Token - write by cursor
 */
export function hasValidToken(): boolean {
  const token = getAccessToken();
  return !!(token && token.length > 0);
} 